"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tappedCollectedArtwork = void 0;

var _Schema = require("../../Schema");

/**
 *
 * A user taps an artwork in their My Collection
 *
 * @example
 * ```
 * tappedCollectedArtwork({
 *   destinationOwnerId: "my-artwork-id",
 *   destinationOwnerSlug: "my-artwork-slug",
 * })
 * ```
 */
var tappedCollectedArtwork = function tappedCollectedArtwork(_ref) {
  var contextOwnerId = _ref.contextOwnerId,
      destinationOwnerId = _ref.destinationOwnerId,
      destinationOwnerSlug = _ref.destinationOwnerSlug;
  return {
    action: _Schema.ActionType.tappedCollectedArtwork,
    context_module: _Schema.ContextModule.myCollectionHome,
    context_owner_id: contextOwnerId,
    context_owner_type: _Schema.OwnerType.myCollection,
    destination_owner_id: destinationOwnerId,
    destination_owner_slug: destinationOwnerSlug,
    destination_owner_type: _Schema.OwnerType.myCollectionArtwork
  };
};

exports.tappedCollectedArtwork = tappedCollectedArtwork;